/** Onboarding 功能统一生效人群判断服务。 */
export interface OnboardingEligibilityService {
    /**
     * 同步判断当前账号是否属于 Onboarding 公共目标人群。
     * @returns 已登录且具有账号 ID 的海外个人免费用户返回 true。
     */
    isAudienceEligible(): boolean;
    /**
     * 判断当前账号是否满足启动页 onboarding 生效条件。
     * @returns 符合公共受众、入口未展示且首次评估没有历史任务时，等待统一启动延时后返回 true。
     */
    isEligible(): Promise<boolean>;
    /**
     * 判断当前账号是否满足报告页 onboarding 生效条件。
     * @returns 符合公共受众且首次任务奖励弹窗尚未展示时返回 true。
     */
    isReportEligible(): Promise<boolean>;
    /** 在任一 Agent 的入口引导成功激活后，全局记录入口已展示。 */
    markEntryOnboardingSeen(): void;
}

/** Onboarding 生效人群服务的容器标识。 */
export const OnboardingEligibilityService = Symbol('OnboardingEligibilityService');
